export default {"src":"/_next/static/media/give-icon.e50b0212.svg","height":435,"width":540};